import React, { FC, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import TableTab from "../tabs/table-tab";
import { getFilterTypes, NameOnlyColumn } from "./filterModalUtil";

interface TypeStepProps {
    onNext: (event: any) => void;
    menuId: string | undefined;
}

export const TypeStep: FC<TypeStepProps> = ({ onNext, menuId }) => {
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectAFilterType);
    const [enableNext, setEnableNext] = useState<boolean>(false);

    const onRowClicked = (rowData: any) => {
        const fakeOnclickEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>;
        const eventWithData = { ...fakeOnclickEvent, elementSysname: rowData.elementSysname, name: rowData.nameOriginal };
        setEnableNext(true);
        onNext(eventWithData);
    }

    return <div className="flex flex-col pt-3 pr-3 h-full relative">
        <TableContextProvider
            usePagination
            useTable
            dataMethod={() => getFilterTypes(translate, menuId)}
            tableDescriptor={NameOnlyColumn}
            disableSearch={true}>
            <TableTab
                title={title}
                selectRows={false}
                onRowClicked={(data) => onRowClicked(data)}
                tableId={'filterType'}
                cyName="filterType" />
        </TableContextProvider>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${enableNext ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                    type='button'
                    onClick={onNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
}


